import React, { useEffect, useState } from 'react';
import { Action, Container, Layout, LinkAction, Message, SnackbarActions } from './Snackbar.styles';

// onClick can be a string-link or a function
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Snackbar = ({
  snackbarEntry,
  dispatch
}) => {
  const changeTimeout = 200;
  const {
    message,
    action
  } = snackbarEntry;
  const to = typeof action?.onClick === 'string' ? action?.onClick : undefined;
  const onClick = typeof action?.onClick === 'function' ? action?.onClick : undefined;
  const [show, setShow] = useState(true);
  const [hideSnackbarTimeout, setHideSnackbarTimeout] = useState();
  const [removeSnackbarTimeout, setRemoveSnackbarTimeout] = useState();
  useEffect(() => {
    if (message) {
      const removeSnackbar = () => {
        dispatch({
          type: 'remove-snackbar'
        });
      };
      const hideSnackbar = () => {
        setShow(false);
        const timeoutRemove = window.setTimeout(removeSnackbar, changeTimeout);
        setRemoveSnackbarTimeout(timeoutRemove);
      };
      const timeoutHide = window.setTimeout(hideSnackbar, 5000);
      setRemoveSnackbarTimeout(oldTimeout => {
        clearTimeout(oldTimeout);
        return undefined;
      });
      setHideSnackbarTimeout(oldTimeout => {
        clearTimeout(oldTimeout);
        return timeoutHide;
      });
      setShow(true);
    }
  }, [dispatch, message]);
  const fireAction = () => {
    if (action) {
      clearTimeout(hideSnackbarTimeout);
      clearTimeout(removeSnackbarTimeout);
      dispatch({
        type: 'remove-snackbar'
      });
      if (onClick) {
        onClick();
      }
    }
  };
  return /*#__PURE__*/_jsx(Layout, {
    show: show,
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Message, {
        children: message
      }), action && /*#__PURE__*/_jsxs(SnackbarActions, {
        children: [onClick && /*#__PURE__*/_jsx(Action, {
          onClick: fireAction,
          children: action.text
        }), to && /*#__PURE__*/_jsx(LinkAction, {
          onClick: fireAction,
          to: to,
          children: action.text
        })]
      })]
    })
  });
};